import { makeFunctionReference } from 'convex/server';
import type { LiveVoiceTranscriptFragment } from './live-voice-transcripts';

export type VoiceConversationInfo = {
  id: string;
  startedAt: number;
  endedAt?: number;
  status: 'active' | 'processing' | 'ready' | 'failed';
  partial: boolean;
  summary?: string;
};
export const voiceTranscriptApi = {
  append: makeFunctionReference<
    'mutation',
    {
      orgThreadId: string;
      sessionId: string;
      fragments: LiveVoiceTranscriptFragment[];
      incomplete?: boolean;
    },
    null
  >('your_imai/voice:appendTranscript'),
  info: makeFunctionReference<
    'query',
    { conversationId: string },
    VoiceConversationInfo | null
  >('your_imai/voice:getConversation'),
  transcript: makeFunctionReference<
    'query',
    {
      conversationId: string;
      paginationOpts: { cursor: string | null; numItems: number };
    },
    {
      page: LiveVoiceTranscriptFragment[];
      isDone: boolean;
      continueCursor: string;
    }
  >('your_imai/voice:listTranscript'),
  retry: makeFunctionReference<'mutation', { conversationId: string }, null>(
    'your_imai/voice:retrySummary'
  ),
};
